import VueScrollTo from 'vue-scrollto'
const route = {
  current: null,
  to: null
}
function scrollToTop () {
  if (route.current === route.to) {
    const element = document.querySelector('body')
    VueScrollTo.scrollTo(element, 500, {
      container: 'body',
      easing: 'ease-in-out',
      offset: 0
    })
  }
}
export default {
  bind: function (el, binding, vNode) {
    route.current = binding.value.route
    route.to = vNode.context.$route.path
    el.addEventListener('click', (e) => {
      e.stopPropagation()
      scrollToTop()
    })
  },
  update: function (element, binding, vNode, oldVnode) {
    route.current = binding.value.route
    route.to = vNode.context.$route.path
  }
}



// WEBPACK FOOTER //
// ./src/directives/DirectiveOnRouteMatch.js